import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../authentication.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    constructor(
        private router: Router,
        private authenticationService: AuthenticationService
    ) {
    }

    canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        if (this.authenticationService.checkLoginState() == true) {
            return true;
        } else {
            // We have to use JS window, the router for the component did not load yet.
            const pathname = window.location.pathname;
            if (pathname != '/authentication/login') {
                if (!pathname.includes('/authentication/login/')) {
                    // Validate pathname before encoding
                    if (this.isValidPathname(pathname)) {
                        // Save base64 url to current url.
                        this.router.navigate(['authentication/login/' + btoa(pathname)]);
                    } else {
                        // Invalid pathname, redirect to login without return URL
                        this.router.navigate(['authentication/login']);
                    }
                }
            } else {
                this.router.navigate(['authentication/login']);
            }
            return false;
        }
    }

    /**
     * Validate that the pathname is safe for encoding and later navigation
     * @param pathname The pathname to validate
     * @returns true if pathname is safe, false otherwise
     */
    private isValidPathname(pathname: string): boolean {
        // Ensure pathname starts with /
        if (!pathname || !pathname.startsWith('/')) {
            return false;
        }

        // Block dangerous protocols
        const lowerPath = pathname.toLowerCase();
        if (lowerPath.includes('javascript:') ||
            lowerPath.includes('data:') ||
            lowerPath.includes('vbscript:') ||
            lowerPath.includes('file:')) {
            return false;
        }

        // Only allow alphanumeric, hyphen, underscore, slash, and specific characters
        // This prevents path traversal and other injection attacks
        const validPathRegex = /^[a-zA-Z0-9\-_/.?=&]+$/;
        if (!validPathRegex.test(pathname)) {
            return false;
        }

        return true;
    }
}
